import { CSSObject } from "@emotion/react";
import {
  constants,
  typographyStyles,
  mediaQueryStyles,
} from "@newsela/angelou";

const { ui } = constants.colors;
const { heading1Obj, textXSObj, textLObj } = typographyStyles;
const { mediaQuery: breakpoint } = mediaQueryStyles;
const { Breakpoints } = constants.breakpoints;

export const mainContainerCss: CSSObject = {
  display: "flex",
  zIndex: 1,
  minHeight: "100%",
  // Workaround until GlobalLayout footer gets fixed.
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    marginBottom: "80px",
  },
};

export const containerCss: CSSObject = {
  padding: "1.5rem 2.5rem",
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    padding: "1rem",
  },
};

export const containerPaddingTopModifierCss: CSSObject = {
  padding: "0 2.5rem 2rem",
};

export const contentContainerCss: CSSObject = {
  flexGrow: 1,
  width: "calc(100% - 14.4375rem)",
  [breakpoint.between(Breakpoints.sm, Breakpoints.md)]: {
    width: "calc(100% - 11.625rem)",
  },
  [breakpoint.upTo(Breakpoints.sm)]: {
    width: "100%",
  },
};

export const separatorCss: CSSObject = {
  content: '""',
  background: ui.neutral[100],
  display: "block",
  height: "1px",
  margin: "0 auto",
  width: "calc(100% - 5rem)",
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    width: "calc(100% - 2rem)",
  },
};

export const headerContainerCss: CSSObject = {
  padding: "1.75rem 2.5rem 1.5rem 2.5rem",
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    padding: "1rem",
  },
};

export const headerWithDividerContainerCss: CSSObject[] = [
  headerContainerCss,
  {
    borderBottom: "1px solid",
    borderColor: ui.neutral[100],
  },
];

export const headerCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    flexFlow: "column",
    alignItems: "flex-start",
  },
};

export const titleCss: CSSObject[] = [
  heading1Obj,
  {
    flexGrow: 1,
    margin: 0,
    lineHeight: "3rem",
    color: ui.neutral[700],
    maxWidth: "800px",
    [breakpoint.upTo("xs")]: {
      fontSize: "1.625rem",
      lineHeight: "2rem",
      marginBottom: "1rem",
    },
  },
];

export const descriptionAndMessagesContainerCss: CSSObject = {
  position: "relative",
};

export const breadcrumbsCss: CSSObject[] = [
  {
    [breakpoint.downTo(constants.breakpoints.BreakpointNames.xs)]: {
      marginBottom: 12,
    },
  },
  textXSObj,
  {
    fontSize: "0.75rem",
    lineHeight: "1rem",
    "li > div > div": {
      zIndex: "1000",
    },
  },
  {
    '[aria-current="page"]': {
      textDecoration: "none",
    },
    "li:first-of-type > a": {
      textDecoration: "none",
    },
  },
];

export const descriptionPageCss: CSSObject[] = [
  textLObj,
  {
    margin: "0",
    marginTop: "8px",
  },
  {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
      flexFlow: "column",
      alignItems: "flex-start",
    },
  },
];

export const statusContainerCss: CSSObject = {
  marginBottom: 8,
};
